module.exports = __webpack_public_path__ + "static/media/RECLTD_F1.6996c35f.txt";